import React, { Component, Fragment } from "react";
import Button from "../../components/Button";
import PlayerService from "../../services/players";
import PlayerCard from "../../components/PlayerCard";
import ReCAPTCHA from "react-google-recaptcha";
import { recaptchaKey } from "../../util/constants";

const recaptchaRef = React.createRef();
class PlayerList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPlayers: [],
      players: [],
      captcha: "",
    };
  }

  componentDidMount() {
    const { category } = this.props;

    this.getPlayers(category);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.category !== this.props.category) {
      this.getPlayers(this.props.category);

      this.setState({
        selectedPlayers: [],
      });
    }
  }

  getPlayers = (categoryId) => {
    PlayerService.getPlayers(categoryId).then((response) => {
      this.setState({
        players: response.data.data.sort(() => 0.5 - Math.random()),
        selectedPlayer: null,
      });
    });
  };

  selectPlayer = (player) => {
    this.setState({
      selectedPlayers: [player],
    });
  };

  deselectPlayer = (selectedPlayer) => {
    if (this.state.selectedPlayers.length <= 0) return;

    this.setState({
      selectedPlayers: this.state.selectedPlayers.filter(
        (player) => player.playerId !== selectedPlayer.playerId
      ),
    });
  };

  render() {
    const { onRegisterVote } = this.props;

    const { players, selectedPlayers, captcha } = this.state;

    return (
      <Fragment>
        <div className="Players">
          {players.map((player) => (
            <PlayerCard
              key={player.playerId}
              player={player}
              selectedPlayers={selectedPlayers}
              onSelect={() => {
                this.selectPlayer(player);
              }}
              onDeselect={() => {
                this.deselectPlayer(player);
              }}
            />
          ))}
        </div>

        {selectedPlayers.length > 0 && (
          <div className="SelectedPlayerBar">
            {selectedPlayers.map((player) => (
              <div key={player.playerId} className="SelectedPlayer">
                <img
                  src={`https://static.draft5.gg/jovem-do-ano/players/${
                    player.playerImage || "silhueta-masc.png"
                  }`}
                  alt="Imagem do jogador"
                />

                <span className="SelectedPlayer__name">
                  {player.playerName.split(" ")[0]} "{player.playerNick}"{" "}
                  {player.playerName.replace(
                    player.playerName.split(" ")[0],
                    ""
                  )}{" "}
                  - {player.playerTeam || "Sem time"}
                </span>
              </div>
            ))}

            {captcha == "" && (
              <div className="captchaSolve__container">
                🤖Continuar
                <ReCAPTCHA
                  ref={recaptchaRef}
                  theme="light"
                  sitekey={recaptchaKey}
                  onChange={(value) => {
                    this.setState({ captcha: value });
                  }}
                />
              </div>
            )}

            {captcha != "" && (
              <Button
                onClick={() => {
                  onRegisterVote(selectedPlayers, captcha);
                }}
                text="✅Registrar voto"
                className="SelectedPlayerBar__btn"
              />
            )}
          </div>
        )}
      </Fragment>
    );
  }
}

export default PlayerList;
